import { useTranslation } from "react-i18next"
import Loading from "./Loading"

function PageTitle({
    title = "Title",
    onRefresh = null,
    isLoading = false
}) {

    const [t, i18n] = useTranslation(["global"])

    function refresh() {
        console.log(`Refresh called by ${title} page title`)
        onRefresh()
    }


    return (
        <>
            <h1>{title}</h1>
            {
                onRefresh && !isLoading &&
                <>
                    <button className="btn btn-outline-secondary" onClick={refresh}><i className="fa-solid fa-arrows-rotate"></i> {t("action.refresh")}</button>
                </>

            }
            {
                isLoading == true && <Loading />
            }
            <hr />
        </>
    )
}

export default PageTitle